import { logAttributesFilter } from '@mfs/client/common/log-ga-event'
import { updateAttributesFiltersUI } from '@mfs/client/listings-client/reducers/filters/attributesFilters/attributesFilters'
import { updateAttributesFiltersReq } from '@mfs/client/listings-client/reducers/filters/filterInfo/filterInfo'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export const useAttributeFilters = ({ changeHandler }) => {
  const attributes = useSelector((state) => state?.attributesFilter)
  const activeTabId = useSelector((state) => state?.activeTabId)
  const isEditVisible = activeTabId !== 1

  const dispatch = useDispatch()

  const delayedStateUpdate = useCallback(
    (shouldFireChange = true) => {
      return (...args) => {
        const [payload, meta, displayedAttributes] = args
        dispatch(
          updateAttributesFiltersReq({
            payload,
            meta,
            attributes: displayedAttributes,
            sbsParams: { activeTabId },
          })
        )
        // should not fire the listings call when the user selected none
        if (shouldFireChange && changeHandler) {
          changeHandler()
        }
      }
    },
    [dispatch, changeHandler, activeTabId]
  )

  /** @param {changed} object ex. { [attribute.code]: [boolean] } */
  const attributeHandleChange = useCallback(
    (changed, shouldFireChange = true) => {
      const code = Object.keys(changed)[0]
      const payload = { value: code, checked: changed[code] }

      dispatch(updateAttributesFiltersUI({ payload }))
      logAttributesFilter({ attribute: code, enabled: payload.checked })
      delayedStateUpdate(shouldFireChange)(payload, {}, attributes)
    },
    [dispatch, delayedStateUpdate, attributes]
  )

  const resetClick = useCallback(
    ({ shouldFireChange = true } = {}) => {
      dispatch(updateAttributesFiltersUI({ meta: { isNoneClick: true } }))
      delayedStateUpdate(shouldFireChange)({}, { isNoneClick: true }, [])
    },
    [dispatch, delayedStateUpdate]
  )

  return { attributes, isEditVisible, attributeHandleChange, resetClick }
}
